import { useTranslation } from 'react-i18next';
import { useAccount } from 'wagmi';
import { toast } from 'sonner';
import { IS_DEPLOYED } from '../../lib/contract';
import { mockStore } from '../../lib/mockStore';
import { parseUsdt } from '../../lib/format';

const NotDeployedBanner = () => {
  const { t } = useTranslation();
  const { address, isConnected } = useAccount();
  if (IS_DEPLOYED) return null;

  const handleCredit = () => {
    if (!address || !isConnected) {
      toast.error(t('dashboard.demo.needConnect'));
      return;
    }
    mockStore.creditUsdt(address, parseUsdt('1000'));
    toast.success(t('dashboard.demo.credited'));
  };

  const handleReset = () => {
    if (!address) return;
    mockStore.reset(address);
    toast.success(t('dashboard.demo.resetDone'));
  };

  return (
    <div className="db-banner db-banner--demo" role="status">
      <div className="db-banner__main">
        <i className="fas fa-flask" />
        <div>
          <strong>{t('dashboard.demo.title')}</strong>
          <div className="db-banner__desc">{t('dashboard.demo.desc')}</div>
        </div>
      </div>
      <div className="db-banner__actions">
        <button
          type="button"
          className="sf-btn sf-btn--gold sf-btn--sm"
          onClick={handleCredit}
          disabled={!isConnected}
        >
          <i className="fas fa-coins" /> {t('dashboard.demo.credit')}
        </button>
        <button
          type="button"
          className="sf-btn sf-btn--outline sf-btn--sm"
          onClick={handleReset}
          disabled={!isConnected}
        >
          <i className="fas fa-rotate-left" /> {t('dashboard.demo.reset')}
        </button>
      </div>
    </div>
  );
};

export default NotDeployedBanner;
